const SDK_VERSION = '14.1.1';

export default SDK_VERSION;
